import { Component, DestroyRef, EventEmitter, inject, Input, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MasterdataRequestDTO } from 'src/app/models/MasterdataRequestDTO.model';
import { MasterDataDTO } from 'src/app/models/MasterDataDTO.model';
import { UserDTO } from 'src/app/models/UserDTO.model';
import { CustomerService } from 'src/app/services/customer.service';
import { UserRequestDTO } from 'src/app/shared/models/UserRequestDto';
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { emailValidator } from 'src/app/validators/email.validator';
import { Alert } from 'src/app/shared/models/Alert';
import { AlertService } from 'src/app/shared/services/alert.service';
import { Subject, takeUntil } from 'rxjs';

import { CommonModule } from '@angular/common';
import { FormatPhoneUsDirective } from '../../../directives/format-phone-us.directive';
import { FormatEmailDirective } from '../../../directives/format-email.directive';
@Component({
    selector: 'app-customer-form',
    templateUrl: './customer-form.component.html',
    styleUrls: ['./customer-form.component.css'],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        FormatPhoneUsDirective,
        FormatEmailDirective
    ]
})
export class CustomerFormComponent {
  @Input() customerDataInput: any;
  @Input() isAdmin: boolean = false;
  @Input() isEditing: boolean = false;

    @Output() handleUserLoaded = new EventEmitter<UserDTO>();

  form = new FormGroup({
    email: new FormControl('', [Validators.required, emailValidator()]),
  });

  get emailModel() {
    return this.form.get('email');
  }
  validMail: boolean = false;



  information: string = 'Customer ID/Account: ';
  customerName: string = '';
  address: string = '';
  city: string = '';
  zipCode?: number = undefined;
  stateSelected: string = '';
  states: MasterDataDTO[] = [];
  contactNumber?: string = undefined;
  mainContact?: string = undefined;
  additionalContactNumber?: string = undefined;
  email?: string = '';
  seniorityDate?: string = undefined;
  fieldsCompleted: boolean = false;
  masterdataRequestDTO: MasterdataRequestDTO = {
    idMaster: 1,
  };
  today: string = '';

  customer: UserDTO = {
    userAddressLine1: '',
    userAddressLine2: '',
    userCity: '',
    userMail: '',
    userExpirationPass: new Date('2020-05-05'),
    userNames: '',
    userPassword: '',
    userPhone: undefined,
    userPostalCode: undefined,
    userRegister: new Date('2020-05-05'),
    userState: '',
    userId: undefined,
    userStatus: undefined,
    numberPlans: undefined,
    numberDevices: undefined,
    listUserRole: [],
    listUserPlanDev: []
  };

  UserRequestDTO: UserRequestDTO = {
    userId: undefined,
  };

  alert: Alert = {} as Alert;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private alertService: AlertService,
    private customerService: CustomerService
  ) { }


  ngOnInit() {
    
    this.route.params.subscribe(params => {
      this.UserRequestDTO.userId = params['id']; // Access the 'id' parameter from the URL
      if (this.UserRequestDTO.userId) {
        this.isEditing = true
      }
    });

    const now = new Date();
    this.today = now.toISOString().split('T')[0]; // Formato 'YYYY-MM-DD'
    this.information = this.information + this.UserRequestDTO.userId;
    
    this.customerService.getCustomerById(this.UserRequestDTO).subscribe(
      ({ StatusCode, Message, Data }) =>
        Data != null
          ? this.handleGetUserByIdSuccess(Data)
          : this.handleSaveError(StatusCode),
      (error) => {
        this.alert = {
          alertMessage: 'Unexpected error. Please try again later.',
          alertType: 'alert alert-danger',
          alertCenter: false,
          alerTitle: '',
          duration: 3000
        };
        this.alertService.updateAlertState(
          this.alert
        );
        this.clearFields();
      }
    );

    this.customerService.getMastersById(this.masterdataRequestDTO).subscribe(
      ({ StatusCode, Message, Data }) =>
        Data != null
          ? this.handleGetAllStatesSuccess(Data)
          : this.handleSaveError(StatusCode),
      (error) => {
        this.alert = {
          alertMessage: 'Unexpected error. Please try again later.',
          alertType: 'alert alert-danger',
          alertCenter: false,
          alerTitle: '',
          duration: 3000
        };
        this.alertService.updateAlertState(
          this.alert
        );
        this.clearFields();
      }
    );
  }

  clearFields() {
    this.address = '';
    this.contactNumber = undefined;
    this.customerName = '';
    this.email = '';
    this.stateSelected = '';
    this.zipCode = undefined;
    this.city = '';
  }

  //Este metodo se ejecuta cuando se presiona el boton de regresar
  // goBack() {
  //   this.router.navigate(['/customers']);
  // }

  updateCustomer() {
    this.customer.userAddressLine1 = this.address;
    this.customer.userPhone = this.contactNumber;
    this.customer.userNames = this.customerName;
    this.customer.userMail = this.email;
    this.customer.userState = this.stateSelected;
    this.customer.userPostalCode = this.zipCode;
    this.customer.userCity = this.city;
    this.customer.listUserRole = [];
    this.customer.listUserPlanDev = [];
    this.customer.seniorityDate = this.seniorityDate !== undefined ? new Date(this.seniorityDate) : undefined;
    this.customer.additionalContactNumber = this.additionalContactNumber;
    this.customer.mainContact = this.mainContact;

    this.customerService.updateCustomer(this.customer).subscribe(
      ({ StatusCode, Message, Data }) =>
        Data != null
          ? this.handleSaveSuccess(Data)
          : this.handleSaveError(StatusCode),
      (error) => {
        this.alert = {
          alertMessage: 'Unexpected error. Please try again later.',
          alertType: 'alert alert-danger',
          alertCenter: false,
          alerTitle: '',
          duration: 3000
        };
        this.alertService.updateAlertState(
          this.alert
        );
        this.clearFields();
      }
    );
  }

  checkFields() {
    if (
      this.customerName &&
      this.contactNumber &&
      this.email
    ) {
      this.fieldsCompleted = true;
    } else {
      this.fieldsCompleted = false;
    }
  }

  handleSaveError(StatusCode: number) {
    this.alert = {
      alertMessage: 'Unexpected error. Please try again later.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    this.alertService.updateAlertState(
      this.alert
    );
    this.clearFields();
  }

  async handleSaveSuccess(customer: boolean) {
    this.alert = {
      alertMessage: 'Customer updated successfully',
      alertType: 'alert alert-success',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    localStorage.setItem('AlertObject', JSON.stringify(this.alert));
    this.alertService.updateAlertState(
      this.alert
    );

    this.clearFields();
    location.reload();
  }

  handleGetAllStatesSuccess(states: MasterDataDTO[]) {
    this.states = states;
  }

  handleGetUserByIdSuccess(customer: UserDTO) {
    this.customer = customer;
    this.customerName = this.customer.userNames;
    this.address = customer.userAddressLine1;
    this.zipCode = customer.userPostalCode;
    this.stateSelected = customer.userState;
    this.contactNumber = customer.userPhone;
    this.email = customer.userMail;
    this.city = customer.userCity;
    this.additionalContactNumber = customer.additionalContactNumber;
    this.mainContact = customer.mainContact;
    if (customer.seniorityDateString != null) {
      this.seniorityDate = customer.seniorityDateString.split('T')[0];
    }

    this.handleUserLoaded.emit(this.customer);

    this.checkFields();
  }

  checkEmailValidity() {
    const isValid = this.emailModel?.valid;
    if (isValid) {
      this.validMail = true;
    } else {
      this.validMail = false;
    }

  }
}
